<!--活動大廳-->
<template>
	<div class="page-body">
		<div class="activity-top">
			<div class="at-cn">
				<h1>活動大廳</h1>
				<p>完成活動 獲得更多福利和優惠</p>
			</div>
		</div>

		<div class="activity-home center-wrap">
			<div class="dividing-line"></div>
			<div class="cm-card-title">
				<img alt="" class="icon-square" src="@/assets/img-pc/icon5.png">
				<span class="fade-in-right">長期活動</span>
			</div>
			<ul class="list">
				<li class="card">
					<!-- <img alt="" src="@/assets/img-pc/124.e59d22ee.png" class="lazy-img bg-img"> -->
					<div class="row1">VIP升級活動
						<img alt="" class="icon3"
							src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAaCAYAAACkVDyJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQ8SURBVHgB5ZZNbBtFFMf/sx+OkxLsNrRBQilOlZYiUEk5ICEqNT5RxIFwKUfMEfUSDkhRqGh641bEBYkDODcuCCJxA0oikBAc6hw4ICHFboIURGS8bXfX+zmPNzt14oDjxLnylMmOd+bNb/7vvRkbGNDoh9M36McJotWJWziCCQxo9PWE1B32NaySeLV+dxB/A4Naiz5Ck2EOVgeFHdno41IJRzSDasUi/TTgAi9fKgwyXa2vOBkQzmgNQbpO3z7x5mGckz+vf0lIa3TnXO0w8+m7iQqvX0dr9I4GbvP/vzgnTfNA53hzfoaXmCUYAubINNVmZg50ambrA9tCaGDTLON+Oive2Fii+lyxr7NhzAlVn6rWRI4w/NiNftPb9cWSuLpZxQO8jr+Nsnq3cyzo7ru3kQQzSPwl+N5NcfHzRrczbc2XUpj1zKm9AcPnbv4sYI6XxeQHK3vm1uaKMk+3hD1cEZZVB7nPi8kPHa1QTajPlyCTMpJIIIkrMJLb9MuVSvci0jAyNRwYPoGCQLxXYRCsR/aoTH6+OptSa53idgWRSxT5JcR2qTO+q/D3a98j9lhhm718YrUCkVdF7N/E+SvoqNMKN2F468DwOVb5FKscKQdrXzTM/NCnMIfKwh7idzkISzW7bl745EzH19rZWuwtQ4aXkYZCKw2BNKpAxrOy3WpwvphEShkbPyFZa8qOKSiKP0PaLlCUFmHyO5kwMOahmKdYS90R2L1pQlQzUBqxg4IF3Php2kUaGZvWYeCAMozUtZbBYt5AApEvlMTwieMy8ASFLrt7vAndElUTvYDiYtXhmSscSmh1ISkgnXpa56uTAAVVhcogVi+yzXHfnniJN+2DoVBQhC7J0F0ZfvGrRm+FWcbDRV6AOjAYOcjjZ8ROplUkdYf/OGSS800KmMIonoY4dhKcd0LokVJrRG4V/7I9QPHCN6sc1nsMzvIoH39mt6y6nyqcCkjBQ2ikC2LyMvM9oWCIfLK3m8t9gZmlQTVTZ9lEJ6YyMR1Re7/MEp1r6WuwquOxSYjRcQXlfbhL4q2GczAwiJdV4dD4c0JfRtSlUOxuQKa6sKTHT08rZstNXcqKRQbuEnrYf4Dild+4cMI1OXYWqhyR1QjtqtwxqZUpmHS1Wp5gjj3JLkZj9G135VBAvVZYFff+6FLUgXapVXnMjs+Dh01BAxbchIzai9jH+v7EiLeuz/QccNdgOWuc5zw3vhDyU7qJgoMYDTH5jrPfmtZ+A2njvQUEdJLjwwcLKm4+H0fPhOnDmvZx6oLHR75NlHq2tHy+ELz7tOE/2jzvoY/1BNLG+69JShe46/A11mJoi28yhwPqSCFbvAFWIFo85ljCbPHvBn4XO3aUM1D4NeHoJ9kl38PE/goXrhlk5SQnhj0DXSGsiPsWrCBWn0m27ex9nu8XPzhWsNvYEoF4djHC/9b+Aa7LSuNSwgA3AAAAAElFTkSuQmCC">
					</div>
					<!-- <div class="row2"></div> -->
					<div class="row3">充值升級領取贈金</div>
					<button class="but" @click="$nav.go('/pc/activityVip')">參與活動</button>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {};
		},
		mounted() {

		},
		beforeUnmount() {},
		methods: {

		},
	};
</script>
<style lang="scss" scoped>
	.activity-home {
		min-height: 617px;
		position: relative;
		margin: 30px auto 70px;
		padding: 30px 50px;
		border-radius: 12px;
		border: 2px solid #252731;
		background: #12141e;

		.list {
			.card {
				position: relative;
				width: 400px;
				min-height: 170px;
				margin-right: 25px;
				padding: 26px 20px 12px;
				display: flex;
				flex-direction: column;
				justify-content: space-around;
				border-radius: 12px;
				overflow: hidden;
				color: #fce07b;
				background: url('~@/assets/img-pc/124.e59d22ee.png') no-repeat;
				background-size: 100% 100%;

				.but {
					position: absolute;
					z-index: 4;
					top: 67px;
					right: 15px;
					height: 30px;
					line-height: 15px;
					min-width: 90px;
					display: flex;
					align-items: center;
					justify-content: center;
					padding: 0 10px;
					border-radius: 100px;
					color: #a07300;
					cursor: pointer;
					background: linear-gradient(270deg, #f9cd4f, #fcdf7b);
					border-width: 0;
					font-size: 14px;
				}

				.row1 {
					line-height: 30px;
					font-size: 24px;
					font-weight: 800;
					margin-bottom: 28px;
					display: flex;
					align-items: center;

					.icon3 {
						width: 30px;
						height: 30px;
						margin-left: 10px;
					}
				}
			}
		}

		.cm-card-title {
			width: 100%;
			height: 24px;
			margin-bottom: 15px;
			padding: 0 12px;
			font-size: 20px;
			display: flex;
			flex-wrap: nowrap;
			flex-direction: row;
			align-items: center;
			justify-content: normal;

			.fade-in-right {
				height: 24px;
				line-height: 24px;
				margin-right: auto;
				color: #fff;
			}

			.icon-square {
				flex: none;
				width: 12px;
				height: 12px;
				margin-right: 4px;
			}
		}

		.dividing-line {
			position: relative;
			height: 1px;
			width: 100%;
			background: #252731;
			margin: 30px 0;
		}
	}

	.activity-top {
		width: 100%;
		height: 300px;
		position: relative;
		overflow: hidden;
		background: url('~@/assets/img-pc/121.b75648b1.png') no-repeat;
		background-size: 100% 100%;
		background-color: #0e0f18;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 0 15%;

		h1 {
			font-size: 48px;
			margin-bottom: 17px;
			color: #fff;
			font-weight: 500;
		}

		p {
			font-size: 16px;
			color: #cdcdcd;
		}
	}
</style>